module.exports = __webpack_public_path__ + "static/media/estudiante.3f2ad4c2.svg";